import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Radio, Tooltip, Tag
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { 
    getMacEnrollmentSetting, updateMacEnrollmentSettingAccountInfo
} from "../../axios/api.enroll"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    settingId: string,
    updateSetting: () => void,
}

export const EnrollmentSettingAccountInfo = (props: propsModel) => {
    const { settingId, updateSetting } = props;
    const [dataForm] = Form.useForm();
    const [createLocalAccount, setCreateLocalAccount] = useState<boolean>(false);
    const [autoPopulatePrimaryAccountInfo, setAutoPopulatePrimaryAccountInfo] = useState<boolean>(false);

    const { t } = useTranslation();

    useEffect(() => {
        getDataInfo();
    }, [])

    const getDataInfo = () => {
        if(settingId)
        {
            getMacEnrollmentSetting(settingId).then((res) => {
                if (res && res != null) {
                    var data: any = {};
                    setCreateLocalAccount(res.isCreateLocalAccount);
                    setAutoPopulatePrimaryAccountInfo(res.isAutoPopulatePrimaryAccountInfo);
                    data.isCreateLocalAccount = res.isCreateLocalAccount;
                    data.isAutoPopulatePrimaryAccountInfo = res.isAutoPopulatePrimaryAccountInfo;
                    if(res.isCreateLocalAccount)
                    {
                        data.shortName = res.shortName;
                        data.password = res.password;
                        data.isHidden = res.isHidden;
                        data.accountType = res.accountType;
                    }
                    if(data.isAutoPopulatePrimaryAccountInfo)
                    {
                        data.primaryAccountFullName = res.primaryAccountFullName;
                        data.primaryAccountUserName = res.primaryAccountUserName;
                        data.lockPrimaryAccountInfo = res.lockPrimaryAccountInfo;
                    }

                    dataForm?.setFieldsValue(data);
                }
            })
        }
    }
    const addTemplateClick = () => {
        if(!settingId)
        {
            notification.warning({ message: t("请先配置基本信息") });
            return;
        }
        dataForm?.validateFields().then(
            (res) => {
                var req: any = {};
                req.isCreateLocalAccount = res.isCreateLocalAccount;
                req.isAutoPopulatePrimaryAccountInfo = res.isAutoPopulatePrimaryAccountInfo;
                if(req.isCreateLocalAccount)
                {
                    req.shortName = res.shortName;
                    req.password = res.password;
                    req.isHidden = res.isHidden;
                    req.accountType = res.accountType;
                }
                if(req.isAutoPopulatePrimaryAccountInfo)
                {
                    req.primaryAccountFullName = res.primaryAccountFullName;
                    req.primaryAccountUserName = res.primaryAccountUserName;
                    req.lockPrimaryAccountInfo = res.lockPrimaryAccountInfo;
                }
                updateMacEnrollmentSettingAccountInfo(settingId, req).then(() => {
                    notification.success({ message: t("成功") });
                    //dataForm.resetFields();
                    getDataInfo();
                })
            })
    }
    const cancelClick = () => {
        dataForm?.resetFields();
        updateSetting();
        getDataInfo();
    }

    return (<>
        <div>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>       
                <Form
                    style={{ width: "90%", marginTop: 36 }}
                    layout="horizontal"
                    form={dataForm}
                    labelCol={{ span: 8 }}
                    initialValues={{isCreateLocalAccount: false, accountType: "Regular", isAutoPopulatePrimaryAccountInfo: false,
                          isHidden: false, lockPrimaryAccountInfo: false}}
                >
                    <Item label={t("在MacOS激活时创建本地账户")} name="isCreateLocalAccount">
                        <Select style={{width:"50%"}} onChange={(key: boolean) => {
                            setCreateLocalAccount(key);
                        }}>
                            <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                            <Select.Option value={true}>{t("设置")}</Select.Option>
                        </Select>
                    </Item>
                    {createLocalAccount && <>
                        <Item 
                            label={t("用户名")} 
                            name="shortName"
                            style={{paddingLeft:"100px"}}
                            rules={[{ required: true }]}
                        >
                            <Input  style={{width:"50%"}}></Input>
                        </Item>
                        <Item 
                            label={t("密码")} 
                            name="password"
                            style={{paddingLeft:"100px"}}
                            rules={[{ required: true }]}
                        >
                            <Input.Password  style={{width:"50%"}}></Input.Password>
                        </Item>
                        <Item 
                            label={t("隐藏此账户")} 
                            name="isHidden"
                            style={{paddingLeft:"100px"}}
                            rules={[{ required: true }]}
                        >
                            <Select style={{width:"50%"}}>
                                <Select.Option value={true}>{t("是")}</Select.Option>
                                <Select.Option value={false}>{t("否")}</Select.Option>
                            </Select>
                        </Item>
                        <Item 
                            label={t("注册时创建的账户类型")} 
                            name="accountType"
                            style={{paddingLeft:"100px"}}
                            rules={[{ required: true }]}
                        >
                            <Select style={{width:"50%"}}>
                                <Select.Option value={"Regular"}>{t("普通用户")}</Select.Option>
                                <Select.Option value={"Admin"}>{t("管理员")}</Select.Option>
                                <Select.Option value={"Skip"}>{t("不创建账户")}</Select.Option>
                            </Select>
                        </Item>
                    </>}
                    <Item label={t("预先填写账户信息")} name="isAutoPopulatePrimaryAccountInfo">
                        <Select style={{width:"50%"}} onChange={(key: boolean) => {
                            setAutoPopulatePrimaryAccountInfo(key);
                        }}>
                            <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                            <Select.Option value={true}>{t("设置")}</Select.Option>
                        </Select>
                    </Item>
                    {autoPopulatePrimaryAccountInfo && <>
                        <Item 
                            label={t("用户名全称")} 
                            name="primaryAccountFullName"
                            style={{paddingLeft:"100px"}}
                        >
                            <Input style={{width:"50%"}}></Input>
                        </Item>
                        <Item 
                            label={t("用户名")} 
                            name="primaryAccountUserName"
                            style={{paddingLeft:"100px"}}
                        >
                            <Input style={{width:"50%"}}></Input>
                        </Item>
                        <Item 
                            label={t("锁定主要账户信息")} 
                            name="lockPrimaryAccountInfo"
                            style={{paddingLeft:"100px"}}
                        >
                            <Select style={{width:"50%"}}>
                                <Select.Option value={true}>{t("是")}</Select.Option>
                                <Select.Option value={false}>{t("否")}</Select.Option>
                            </Select>
                        </Item>
                    </>}
                </Form>
                <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                    <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                    <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { cancelClick(); }}>{t("取消")}</Button>
                </div>
            </Row>
        </div>

    </>)
};
